export const accountUrl = 'me/';
export const accountEventsUrl = 'me/notifications/';
export const accountEventsBulkUrl = 'me/notifications/bulk/';
export const getSubAccountsUrl = 'sub-accounts/';
